const NoiseOverlay = () => {
  // SVG feTurbulence filter as data URI for noise grain
  const noiseSvg = `url("data:image/svg+xml,%3Csvg viewBox='0 0 256 256' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noise'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.65' numOctaves='3' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23noise)'/%3E%3C/svg%3E")`;

  return (
    <div
      className="fixed inset-0 pointer-events-none"
      style={{
        zIndex: 1,
        backgroundImage: noiseSvg,
        backgroundRepeat: 'repeat',
        mixBlendMode: 'overlay',
        opacity: 0.25,
      }}
      aria-hidden="true"
    />
  );
};

export default NoiseOverlay;
